import type { Session } from '@/types/session'

import config, { embeddedRuntime } from '@/config'

export const initPendo = async (session: Session) => {
  // Return a mock in test environments or when window is not available
  if (typeof window === 'undefined' || process.env.NODE_ENV === 'test') {
    return {
      // Mock Pendo object for testing
      identify: () => {
        /* mock */
      },
      track: () => {
        /* mock */
      },
      show: () => {
        /* mock */
      },
      hide: () => {
        /* mock */
      },
    }
  }

  // Dynamic import to avoid issues in test environments
  const { initialize, TextCapture } = await import('@pendo/agent')

  const pendo = await initialize({
    apiKey: config.pendoIdentifier,
    env: 'io',
    visitor: {
      id: session.user.id, // Required if user is logged in
      email: session.user.email, // Recommended if using Pendo Feedback, or NPS Email
      full_name: session.user.name, // Recommended if using Pendo Feedback
      role: session.account.role,
      workspaceRole: session.workspace?.role?.toString(), // Optional, if you want to track workspace roles
      locale: session.user.locale,
      joinedAt: session.user.joinedAt,
      extensionUser: !!embeddedRuntime(),
      screenWidth: window.screen.width,
      windowWidth: window.innerWidth,
      screenHeight: window.screen.height,
      windowHeight: window.innerHeight,
    },
    account: {
      id: session.account.id, // Highly recommended, required if using Pendo Feedback
      name: session.account.name,
    },
    plugins: [TextCapture],
    enableDebugEvents: false, // Set to true for debugging purposes
  })

  // pendo.validateEnvironment() // Uncomment this line if you want to validate Pendo identity data

  return pendo
}
